<template>
  <basic-container v-if="showBaseForm">
    <avue-crud
      :option="option"
      :table-loading = "loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
      >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openAddForm"
        >新  增
        </el-button>
        <el-button
          size="small"
          icon="el-icon-sort"
          :loading = "syncButtonLoading"
          @click="syncParkInfo(1)">同步
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" @click="toEdit(scope.row)">
          <span class="el-icon-edit"></span>编辑
        </el-button>
      </template>
    </avue-crud>
    <div v-show="showParkForm" >
      <avue-form ref="parRegionForm" v-model="form" :rules="rules" :option="option" @submit="submit">
        <template slot-scope="scope" slot="menuForm">
          <el-button @click="emptyChange" icon="el-icon-delete">清空</el-button>
        </template>
      </avue-form>
    </div>
  </basic-container>
</template>

<script>
  import {getParkParent,getRegionList,numberCheck,stringCheck} from '@/views/v4ward/car/merge/api/park-merge';
  import {update,addParkSpaceNode} from '@/api/v4ward/car/carpark';
  import { syncData } from '@/api/v4ward/car/carparkspace';
  export  default {
    props: {
      parkSpace: {},
      showBaseForm: false,
    },
    data() {
      var checkRegion = (rule, value, callback) => {
        if(value === this.form.id){
          callback(new Error('父级节点不能选自己！'));
        }else{
          callback();
        }
      };
      return{
        loading: false,
        showParkForm: false,
        operateType: '',
        form: {},
        syncButtonLoading: false,
        spaceId: '',
        option: {
          calcHeight: 350,
          tip: false,
          border: true,
          index: false,
          selection: false,
          columnBtn: false,
          viewBtn: false,
          addBtn: false,
          editBtn: false,
          delBtn: false,
          menuType: 'text',
          refreshBtn:false,
          emptyBtn: false,
          align: 'center',
          menuWidth: 100,
          column: [
            {
              label: '区域名称',
              prop: 'spaceName',
              rules: [{
                required: true,
                trigger: 'blur',
                message: '请输入区域名称'
              },{
                validator: stringCheck,
                min: 2,
                max: 10,
                trigger: 'blur',
              },]
            },
            {
              label: '上级节点',
              prop: 'parentId',
              type: 'tree',
              props: {
                label: 'title',
                value: 'key',
              },
              rules: [
                {
                  required: true,
                  message: '请选择上级节点',
                  trigger: 'blur',
                },
                {
                  validator: checkRegion,
                  message: '请选择上级节点',
                  trigger: 'change',
                },
              ],
              //dicUrl: '/api/v4ward/car/ParkSpace/merge/regionParentNodes?id=' + this.parkSpace.id,
              dicData: [],
            },
            {
              label: '车位数',
              prop: 'parkLotNumber',
              type: 'number',
              rules: [{
                required: true,
                message: "请输入车位数",
                trigger: "blur"
              },{
                validator: numberCheck,
                min: 10,
                max: 10000,
                trigger: 'blur',
              },]
            },
            {
              label: '临停车位',
              prop: 'tempParkFlag',
              type: 'select',
              dicData:[
                {label: '是',value: '1'},
                {label: '否',value: '0'},
              ]
            },
            {
              label: '状态',
              prop: 'carParkStatus',
              type: 'select',
              dataType: 'number',
              dicUrl: '/api/blade-system/dict/dictionary?code=car_park_status',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              }
            },
            {
              label: '单独计费',
              prop: 'carParkAreaType',
              type: 'select',
              dataType: 'number',
              dicUrl: '/api/blade-system/dict/dictionary?code=park_area_fee_type',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              rules: [{
                required: true,
                message: "请选择是否单独计费",
                trigger: "blur"
              }]
            },
            {
              label: '本地编号',
              prop: 'blockLocalNo',
              span: 24,
              hide: true,
              display: false,
            },
          ]
        },
      }
    },
    created() {

    },
    mounted() {
      setTimeout(() =>{
        document.querySelector("#pane-parkRegion > div > div > div").style='padding-top:0px !important';
        document.querySelector("#pane-parkRegion > div > div > div > div.avue-crud > div.avue-crud__pagination").style='padding-top:0px !important';
      });
    },
    methods: {
      openAddForm(){
        this.operateType = 'add';
        this.cleanForm();
        this.showParkForm = !this.showParkForm ;
      },
      toEdit(row){
        this.operateType = 'edit';
        this.form = Object.assign({},row);
        this.showParkForm = !this.showParkForm ;
      },
      onLoad(){
        this.loading = true;
        getRegionList({parkId: this.parkSpace.id,spaceName:this.spaceName,type:3}).then(data =>{
            this.data = data.data;
            this.loading = false;
            this.initParkParentList();
          }
        );
      },

      initParkParentList(force){
        if(this.spaceId === '' || this.spaceId !== this.parkSpace.id || force){
          getParkParent({id:this.parkSpace.id}).then(({ data }) =>{
            const col = this.findObject(this.option.column, 'parentId');
            if (this.vdui.isNotEmpty(data)) {
              col.dicData = data;
            } else {
              col.dicData = [{}];
            }
          })
        }
        this.spaceId = this.parkSpace.id;
        if(this.parkSpace.equType === 3){
          const blockLocalNo = this.findObject(this.option.column, 'blockLocalNo');
          blockLocalNo.display = true;
        }else {
          const blockLocalNo = this.findObject(this.option.column, 'blockLocalNo');
          blockLocalNo.display = false;
        }
      },

      emptyChange(){
        if(this.operateType === 'add'){
          this.cleanForm();
        }else {
          this.$message.warning('编辑时清空无效！');
        }
      },
      submit (form,done) {
        this.form.type = 3;
        if(this.vdui.isEmpty(this.form.tempParkFlag)){
          this.form.tempParkFlag = 0;
        }
        if(this.vdui.isEmpty(this.form.carParkStatus)){
          this.form.carParkStatus = 0;
        }
        if(this.vdui.isEmpty(form.id)){
          addParkSpaceNode(this.form).then(() => {
              done();
              this.$message.success('操作成功!');
              this.cleanForm();
              this.onLoad();
              this.initParkParentList(true);
          },(error) => {
            done();
            console.log(error);
          });
        }else{
          update(this.form).then(() => {
              done();
              this.$message.success('操作成功!');
              this.cleanForm();
              this.onLoad();
              this.initParkParentList(true);
              this.showParkForm = false;
            },
            (error) => {
              done();
              console.log(error);
            }
          );
        }
      },
      syncParkInfo(type) {
        this.syncButtonLoading = true;
        const  syncParam = {
          dataRange: 2,
          dataType: type,
          parkId: this.parkSpace.id,
        };
        syncData(syncParam).then(
          () => {
            this.$message.success('操作成功！');
            this.syncButtonLoading = false;
          },
          (error) => {
            window.console.log(error);
            this.syncButtonLoading = false;
          }
        );
      },
      cleanForm() {
        for(let key in this.form){
            this.form[key] = '';
        }
      },
    },



  }


</script>
<style scoped>
</style>
